import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import TradeBenefitsSection from '../../sections/TradeBenefitsSection'
import WebtraderSection from '../../sections/WebtraderSection'
import { mapButtonProps } from '../../atoms/Button/utils'
import { ComponentSectionSliceProps } from './types'

const ComponentSectionSlice: React.FC<ComponentSectionSliceProps> = ({ slice }) => {
  const { group } = usePageContext()

  const {
    layout,
    title,
    is_main_heading,
    image,
    video,
    benefits = [],
    icons = [],
    button_text,
    button_type,
    button_link,
    button_is_centered,
    button_caption,
    button_caption_mobile_size,
    button_caption_desktop_size
  } = slice.primary?.component?.document?.data || {}

  const listItems = benefits.map((item, index) => ({
    key: `${index}`,
    label: item?.benefit
  }))

  const iconsList = icons.map((item, index) => ({
    key: index,
    title: item?.icon_title,
    icon: item?.icon
  }))

  const media = {
    image: {
      publicURL: image?.url,
      childImageSharp: image && {
        gatsbyImageData: image.gatsbyImageData
      },
      width: image?.dimensions?.width,
      height: image?.dimensions?.height,
      alt: image?.alt
    },
    video: {
      url: video?.url
    }
  }

  const cta = mapButtonProps(
    button_type,
    button_text,
    resolvePrismicLink(button_link, group),
    button_link?.link_type,
    button_caption,
    button_caption_mobile_size,
    button_caption_desktop_size,
    button_is_centered
  )

  switch (layout) {
    case 'left_right':
      return (
        <TradeBenefitsSection
          heading={title?.text}
          isMainHeading={is_main_heading}
          paddingTop={['4rem', '', '']}
          paddingBottom={['5rem', '6rem', '12rem']}
          data={{
            listItems,
            media,
            iconsList
          }}
          bgColor="#F8FAFF"
          inner="inners.primary"
        />
      )
    case 'bottom':
      return (
        <WebtraderSection
          heading={title?.text}
          isMainHeading={is_main_heading}
          paddingTop={['4rem', '', '']}
          paddingBottom={['4rem', '', '']}
          data={{
            listItems,
            cta,
            media,
            iconsList
          }}
          bgColor="#F8FAFF"
          inner="inners.primary"
        />
      )
    default:
      return null
  }
}

export default ComponentSectionSlice
